import * as requestFromServer from "./libraryCrud";
import { organizationLibrarySlice, callTypes } from "./librarySlice";
import { actions as auth } from "../../Auth/_redux/authRedux";
import { toastOption } from "../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = organizationLibrarySlice;

export const fetchLibrarys = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findlibraryFolder(queryParams)
    .then(response => {
      const {
        data: { items }
      } = response.data;
      dispatch(actions.librarysFetched({ items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchFiles = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findlibraryFile(queryParams)
    .then(response => {
      const {
        data: { items }
      } = response.data;
      dispatch(actions.libraryFilesFetched({ items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createLibraryFile = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createLibraryFile(payload)
    .then(response => {
      dispatch(actions.libraryReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};
